import {Grid, Typography} from "@mui/material";
import portada_servicios from "../../../Recursos/portada_servicios.png";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import Portada_SobreMi from "./Portada_SobreMi";
import Lista_Equipo from "./SubComponentes/Lista_Equipo";

const Nuestro_Nosotros = () => {

    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container  alignItems={'flex-start'} size={{xs: 12, sm: 12, md: 10}} sx={{maxWidth: 1400, px: 3 }} >
                <Grid container size={{xs: 12, sm: 12, md: 12}} >
                    <Lista_Equipo />
                </Grid>

            </Grid>
        </Grid>
    )

}
export default Nuestro_Nosotros





// <Grid
// container
// justifyContent={'center'}
// alignItems={'flex-start'}
// size={{xs: 12, sm: 12, md: 12}}>
//
// <Grid container  alignItems={'flex-start'} size={{xs: 12, sm: 12, md: 10}} sx={{maxWidth: 1400, px: 3, py:12, }} >
// <Grid container size={{xs: 12, sm: 12, md: 12}} >
// <Lista_Equipo />
// </Grid>
//
// </Grid>
// </Grid>